module.exports = __webpack_public_path__ + "img/vpackslogo.911d681b.png";